export default () =>[
    {
        field: 'seq',
        width: 50,
        align: 'center',
        fixed: 'left',
        type: 'seq',
    },
    {
        field: 'col-opt',
        title: '操作',
        headerAlign: 'center',
        align: 'left',
        fixed: 'left',
        width: 110,
        slots: {
          default: 'opt',
        },
    },
    {
        field: 'icechopsNo',
        align: 'center',
        width: 100,
        title: '冰排编号',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'icechopsLength',
        align: 'center',
        width: 100,
        title: '冰排长度',
        sortable: true,
        sortType: 'float',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'icechopsWidth',
        align: 'center',
        width: 100,
        title: '冰排宽度',
        sortable: true,
        sortType: 'float',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'icechopsHeight',
        align: 'center',
        width: 100,
        title: '冰排高度',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'tempRange',
        align: 'center',
        width: 100,
        title: '温度范围',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'orderNo',
        align: 'center',
        width: 100,
        title: '订单编号',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'coolerNo',
        align: 'center',
        width: 100,
        title: '冷藏箱编号',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'icechopsStatus',
        width: 100,
        title: '有效状态',
        slots: { default: 'status' },
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'createByName',
        align: 'center',
        width: 100,
        title: '创建人',
        sortable: true,
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'createTime',
        align: 'center',
        width: 100,
        title: '创建时间',
        sortable: true,
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'modifyByName',
        align: 'center',
        width: 100,
        title: '修改人',
        sortable: true,
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'modifyTime',
        align: 'center',
        width: 100,
        title: '修改时间',
        sortable: true,
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
]